// src/constants/brands.js
import ACM from "../assets/img/brands/acm.png";
import Anivagene from "../assets/img/brands/anivagene.png";
import Avene from "../assets/img/brands/avene.png";
import Beeslin from "../assets/img/brands/beeslin.png";
import Biobalance from "../assets/img/brands/biobalance.png";
import Bioclin from "../assets/img/brands/bioclin.png";
import Bioderma from "../assets/img/brands/bioderma.png";
import Biomagic from "../assets/img/brands/biomagic.png";
import BioOil from "../assets/img/brands/bio-oil.png";
import ColorSoin from "../assets/img/brands/color&soin.png";
import Cumlaude from "../assets/img/brands/cumlaude.png";
import Deniz from "../assets/img/brands/Deniz.png";
import Ducray from "../assets/img/brands/Ducray.png";
import Ecrinal from "../assets/img/brands/ecrinal.png";
import Filorga from "../assets/img/brands/filorga.png";
import Foltene from "../assets/img/brands/foltene.png";
import Htderm from "../assets/img/brands/htderm.png";
import Isispharma from "../assets/img/brands/isispharma.png";
import LaRochePosay from "../assets/img/brands/laroche-posay.png";
import MadesBR from "../assets/img/brands/madesBR.png";
import Malizia from "../assets/img/brands/Malizia.png";
import Miamo from "../assets/img/brands/miamo.png";
import Mustela from "../assets/img/brands/mustela.png";
import Noreva from "../assets/img/brands/noreva.png";
import Rilastil from "../assets/img/brands/rilastil.png";
import Sesderma from "../assets/img/brands/sesderma.png";
import Svr from "../assets/img/brands/svr.png";
import Uriage from "../assets/img/brands/uriage.png";
import Vichy from "../assets/img/brands/vichy.png";
import Chicco from "../assets/img/brands/chicco.png";
import Century21st from "../assets/img/brands/21stcentury.png";
import Adipharm from "../assets/img/brands/adipharm.png";
import AdrienGagnon from "../assets/img/brands/adriengagnon.png";
import Advacare from "../assets/img/brands/advacare.png";
import Advalife from "../assets/img/brands/advalife.png";
import AMS from "../assets/img/brands/AMS.png";
import BasicNutrition from "../assets/img/brands/basicnutrition.png";
import BioactiveT from "../assets/img/brands/bioactiveT.png";
import Biotonics from "../assets/img/brands/biotonics.png";
import Doppelherz from "../assets/img/brands/doppelherz.png";
import Fines from "../assets/img/brands/fines.png";
import Greenfields from "../assets/img/brands/greenfields.png";
import Himalaya from "../assets/img/brands/Himalaya.png";
import Lacolina from "../assets/img/brands/lacolina.png";
import Madamar from "../assets/img/brands/madamar.png";
import Maddox from "../assets/img/brands/maddox.png";
import MrGummy from "../assets/img/brands/mrgummy.png";
import NaturesAid from "../assets/img/brands/naturesaid.png";
import NaturesBounty from "../assets/img/brands/naturesbounty.png";
import Newgate from "../assets/img/brands/newgate.png";
import PharmaDev from "../assets/img/brands/pharmadev.png";
import Sugarbear from "../assets/img/brands/sugarbear.png";
import Sunlife from "../assets/img/brands/sunlife.png";
import Topcure from "../assets/img/brands/topcure.png";
import Versalya from "../assets/img/brands/versalya.png";
import Vitabiotics from "../assets/img/brands/vitabiotics.png";
import WebberNaturals from "../assets/img/brands/webbernaturals.png";
import Higeen from "../assets/img/brands/higeen.png";
import Kin from "../assets/img/brands/kin.png";
import Lacalut from "../assets/img/brands/Lacalut.png";
import Lacer from "../assets/img/brands/lacer.png";
import Sesodyne from "../assets/img/brands/sesodyne.png";
import Splat from "../assets/img/brands/splat.png";
import Tepe from "../assets/img/brands/tepe.png";
import Wisdom from "../assets/img/brands/wisdom.png";



export const cosmeticBrands = [
    { id: 1, img_url: ACM, alt: "ACM Logo" },
    { id: 2, img_url: Anivagene, alt: "Anivagene Logo" },
    { id: 3, img_url: Avene, alt: "Avene Logo" },
    { id: 4, img_url: Beeslin, alt: "Beeslin Logo" },
    { id: 5, img_url: Biobalance, alt: "Biobalance Logo" },
    { id: 6, img_url: Bioclin, alt: "Bioclin Logo" },
    { id: 7, img_url: Bioderma, alt: "Bioderma Logo" },
    { id: 8, img_url: Biomagic, alt: "Biomagic Logo" },
    { id: 9, img_url: BioOil, alt: "Bio-Oil Logo" },
    { id: 10, img_url: ColorSoin, alt: "Color & Soin Logo" },
    { id: 11, img_url: Cumlaude, alt: "Cumlaude Logo" },
    { id: 12, img_url: Deniz, alt: "Deniz Logo" },
    { id: 13, img_url: Ducray, alt: "Ducray Logo" },
    { id: 14, img_url: Ecrinal, alt: "Ecrinal Logo" },
    { id: 15, img_url: Filorga, alt: "Filorga Logo" },
    { id: 16, img_url: Foltene, alt: "Foltene Logo" },
    { id: 17, img_url: Htderm, alt: "HTDerm Logo" },
    { id: 18, img_url: Isispharma, alt: "Isispharma Logo" },
    { id: 19, img_url: LaRochePosay, alt: "La Roche-Posay Logo" },
    { id: 20, img_url: MadesBR, alt: "MadesBR Logo" },
    { id: 21, img_url: Malizia, alt: "Malizia Logo" },
    { id: 22, img_url: Miamo, alt: "Miamo Logo" },
    { id: 23, img_url: Mustela, alt: "Mustela Logo" },
    { id: 24, img_url: Noreva, alt: "Noreva Logo" },
    { id: 25, img_url: Rilastil, alt: "Rilastil Logo" },
    { id: 26, img_url: Sesderma, alt: "Sesderma Logo" },
    { id: 27, img_url: Svr, alt: "SVR Logo" },
    { id: 28, img_url: Uriage, alt: "Uriage Logo" },
    { id: 29, img_url: Vichy, alt: "Vichy Logo" },
    { id: 30, img_url: Chicco, alt: "Chicco Logo" },
];
export const supplementBrands = [
    { id: 1, img_url: Century21st, alt: "21st Century Logo" },
    { id: 2, img_url: Adipharm, alt: "Adipharm Logo" },
    { id: 3, img_url: AdrienGagnon, alt: "Adrien Gagnon Logo" },
    { id: 4, img_url: Advacare, alt: "Advacare Logo" },
    { id: 5, img_url: Advalife, alt: "Advalife Logo" },
    { id: 6, img_url: AMS, alt: "AMS Logo" },
    { id: 7, img_url: BasicNutrition, alt: "Basic Nutrition Logo" },
    { id: 8, img_url: BioactiveT, alt: "BioactiveT Logo" },
    { id: 9, img_url: Biotonics, alt: "Biotonics Logo" },
    { id: 10, img_url: Doppelherz, alt: "Doppelherz Logo" },
    { id: 11, img_url: Fines, alt: "Fines Logo" },
    { id: 12, img_url: Greenfields, alt: "Greenfields Logo" },
    { id: 13, img_url: Himalaya, alt: "Himalaya Logo" },
    { id: 14, img_url: Lacolina, alt: "Lacolina Logo" },
    { id: 15, img_url: Madamar, alt: "Madamar Logo" },
    { id: 16, img_url: Maddox, alt: "Maddox Logo" },
    { id: 17, img_url: MrGummy, alt: "Mr Gummy Logo" },
    { id: 18, img_url: NaturesAid, alt: "Natures Aid Logo" },
    { id: 19, img_url: NaturesBounty, alt: "Natures Bounty Logo" },
    { id: 20, img_url: Newgate, alt: "Newgate Logo" },
    { id: 21, img_url: PharmaDev, alt: "PharmaDev Logo" },
    { id: 22, img_url: Sugarbear, alt: "Sugarbear Logo" },
    { id: 23, img_url: Sunlife, alt: "Sunlife Logo" },
    { id: 24, img_url: Topcure, alt: "Topcure Logo" },
    { id: 25, img_url: Versalya, alt: "Versalya Logo" },
    { id: 26, img_url: Vitabiotics, alt: "Vitabiotics Logo" },
    { id: 27, img_url: WebberNaturals, alt: "Webber Naturals Logo" },
];

export const dentalBrands = [
    { id: 1, img_url: Higeen, alt: "Higeen Logo" },
    { id: 2, img_url: Kin, alt: "Kin Logo" },
    { id: 3, img_url: Lacalut, alt: "Lacalut Logo" },
    { id: 4, img_url: Lacer, alt: "Lacer Logo" },
    { id: 5, img_url: Sesodyne, alt: "Sesodyne Logo" },
    { id: 6, img_url: Splat, alt: "Splat Logo" },
    { id: 7, img_url: Tepe, alt: "Tepe Logo" },
    { id: 8, img_url: Wisdom, alt: "Wisdom Logo" },
];
